import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import {
  Grid,
  IconButton,
  styled,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CustomAutoComplete from "../CommonComponents/CustomAutoComplete";
import CustomButton from "../CommonComponents/Button";

const ModalHeader = styled("div")({
  fontSize: "20px",
  fontWeight: "700",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  position: "sticky",
  top: 0,
  background: "#fff",
  zIndex: 9,
  paddingTop: "10px",
  borderBottom: "1px slid red",
});
const ModalBody = styled("div")({
  padding: "15px",
});
export default function ReAssignedModal(props) {
  const { title, width, openModal, setOpenModal, ReassignedUserList ,updateUserHandler,setReassignedUserId} = props;

  const handleClose = () => setOpenModal(false);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: width ? width : "50%",
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "10px",
    overflow: "hidden",
    height: "50vh",
    overflow: "auto",
  };





  return (
    <div>

      <Modal
        open={openModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <ModalHeader>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              style={{ marginLeft: "15px" }}
            >
              {title}
            </Typography>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </ModalHeader>
          <ModalBody>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
              }}
            >

              <Grid
                xs={12}
                container
                direction="row"
                justifyContent="flex-start"
                sx={{ marginTop: "10px" }}
              //</ModalBody> alignItems="center"
              >
                <Grid item xs={2}>
                  Company User*
                </Grid>
                <Grid item xs={8}>
                  <CustomAutoComplete
                    disablePortal
                    id="user"

                    options={ReassignedUserList || []
                    }
                    getOptionLabel={(option) => `${option.name}(${option.empCode})`}
                    getOptionSelected={(option, value) =>
                      option.name ===
                      (value != null && value.name != null ? value.name : "")
                    }
                    filterSelectedOptions
                   onChange={(value, newVal) => setReassignedUserId(newVal)}
                    sx={{ width: "auto" }}
                    // value={userId}
                    renderInput={(params) => (
                      <TextField {...params} label="Company Users" />
                    )}
                    size="small"
                  />


                </Grid>
              </Grid>
            </Box>
            <Grid
              container
              direction="row"
              justifyContent="flex-end"
              alignItems="flex-end"
              sx={{ marginTop: "290px" }}
              spacing={4}
            >
              <Grid item><CustomButton name={"Cancel"} onClick={handleClose} sx={{ margin: "10px" }} /></Grid>
              <Grid item>
                <CustomButton name={"Update User"} onClick={updateUserHandler} />
              </Grid>

            </Grid>
          </ModalBody>
        </Box>
      </Modal>
    </div>
  );
}
